module.exports = __webpack_public_path__ + "static/media/e-commerce.4bb22b98.png";